import React from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core';
import MuiSwipeableDrawer from '@material-ui/core/SwipeableDrawer';

export type SwipeableDrawerProps = import('@material-ui/core/SwipeableDrawer').SwipeableDrawerProps;

const useStyles = makeStyles(theme => ({
  fullWidth: {
    width: '100%',
  },
}));

interface CustomProps {
  fullWidth?: boolean;
}

const SwipeableDrawer = React.forwardRef<
  HTMLElement,
  CustomProps & SwipeableDrawerProps
>(({ fullWidth, classes, ...rest }, ref) => {
  const customClasses = useStyles();

  return (
    <MuiSwipeableDrawer
      {...rest}
      ref={ref as React.RefObject<HTMLElement>}
      classes={
        fullWidth
          ? {
              ...classes,
              paper: cx(classes?.paper, customClasses.fullWidth),
            }
          : classes
      }
    />
  );
});

export default SwipeableDrawer;
